import React from 'react';
import classNames from 'classnames';

export interface ListItemProps {
  id?: string;
  className?: string;
  children?: React.ReactNode;
  alignItems?: 'baseline' | 'center' | 'flex-end' | 'flex-start';
  divider?: boolean;
  disablePadding?: boolean;
}

const ListItem: React.FC<ListItemProps> = (props: ListItemProps) => {
  const {
    id,
    className,
    children,
    alignItems = 'center',
    divider,
    disablePadding,
  } = props;

  const listItemClass = classNames(
    'ui-listitem',
    `ui-listitem--alignItems-${alignItems}`,
    {
      'ui-listitem--disablePadding': disablePadding,
      'ui-listitem--divider': divider,
    },
    className
  );

  return (
    <li id={id} className={listItemClass}>
      {children}
    </li>
  );
};

export default ListItem;
